/**
 *
 * Returns the specified block Typography Styles
 * @param theme Block Theme object
 * @returns React CSS Properties object
 */
export default function getTypographyStyles(theme, block) {
    const { attributes } = block;
    const styles = {};
    if (attributes === null || attributes === void 0 ? void 0 : attributes.fontFamily) {
        // TODO: Have a CSS Var generator strategy generate those.
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        styles.fontFamily = `var(--wp--preset--font-family--${attributes.fontFamily})`;
    }
    if (attributes === null || attributes === void 0 ? void 0 : attributes.fontSize) {
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        styles.fontSize = `var(--wp--preset--font-size--${attributes.fontSize})`;
    }
    return styles;
}
